import { SurfaceType } from 'containers/likes/types/likes'

export enum NotificationsQueryKeys {
  NOTIFICATIONS = 'notifications',
}

export enum NotificationTypes {
  LIKE = 'like',
  CONNECTION_CREATED = 'connection_created',
  NETWORK_PROJECT_CREATED = 'network_project_created',
  NETWORK_HIGHLIGHT_CREATED = 'network_highlight_created',
}

interface NotificationDataBase {
  ownerId: string
  surfaceType: SurfaceType
  referencedId: string
}
export interface LikeNotificationData extends NotificationDataBase {
  userIdLiker: string
}

export interface ConnectionNotificationData {
  userSentRequestId: string
  userReceivedRequestId: string
}

export interface NotificationBase {
  id: string
  // notificationType: NotificationTypes
  userId: string
  createdOn: number
  updatedOn?: number
  // specificData: LikeNotificationData
  read?: boolean
}

export type NotificationDTO = NotificationBase &
  (
    | {
        notificationType: NotificationTypes.LIKE
        specificData: LikeNotificationData
      }
    | {
        notificationType: NotificationTypes.CONNECTION_CREATED
        specificData: ConnectionNotificationData
      }
    | {
        notificationType: NotificationTypes.NETWORK_PROJECT_CREATED
        specificData: NotificationDataBase
      }
    | {
        notificationType: NotificationTypes.NETWORK_HIGHLIGHT_CREATED
        specificData: NotificationDataBase
      }
  )

// Like highlight notification
interface LikeNotificationDataHighlight
  extends Omit<LikeNotificationData, 'surfaceType'> {
  surfaceType: SurfaceType.HIGHLIGHT
}

interface LikeNotificationHighlight
  extends Omit<NotificationDTO, 'specificData'> {
  specificData: LikeNotificationDataHighlight
}

export interface LikeHighlightProps {
  notification: LikeNotificationHighlight
}
